import Avatar from '@components/avatar';
import Button from '@components/button';
import StatCard from '../stat-card';
import styles from './affiliates.module.scss';

const Affiliates = (): JSX.Element => {
    /* Components */

    const AffiliatesPlaceholders: JSX.Element[] = [...new Array(3)].map(
        (_, idx) => (
            <article key={idx} className={styles.list__item}>
                <Avatar src="https://placekitten.com/150" alt="User" />
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Molestias illo repellendus facere! Minima voluptatum
                    pariatur odio molestiae amet illo inventore aliquam.
                </p>
            </article>
        ),
    );

    return (
        <section className={styles.affiliates}>
            <h1 className="user-profile-title">Affiliates</h1>

            <div className={styles['code-box']}>
                <input
                    type="text"
                    className={styles['code-box__input']}
                    placeholder="Enter affiliates code"
                />
                <Button
                    color="green"
                    radius="normal"
                    size="normal"
                    className={styles['code-box__create']}
                >
                    Create
                </Button>
            </div>
            <div className={styles.stats}>
                <StatCard name="Affiliated Users" value={2_761} />
                <StatCard name="Total Claimed" value={1_902} withCoinIcon />
                <StatCard name="Earned Money" value={1_105} withCoinIcon>
                    <Button
                        radius="normal"
                        size="normal"
                        className={styles.stats__claim}
                    >
                        Claim
                    </Button>
                </StatCard>
            </div>
            <div className={styles.list}>{AffiliatesPlaceholders}</div>
        </section>
    );
};

export default Affiliates;
